﻿import { action, computed, makeObservable, observable } from "mobx";

import { CoordinateNotation } from 'msg-ui-react/dist/interfaces/CoordinateNotation';
import { DistanceUnits } from "msg-ui-react/dist/interfaces/DistanceUnits";
import { ScaleLineUnits } from "../controls/MapScaleLine";

import { UnitsState } from "../models/UnitsState";
import { IStateStore, StateStore } from "./StateStore";

export abstract class UnitsBaseStore<S extends UnitsState = UnitsState> extends StateStore<S> implements UnitsState, IStateStore<UnitsState> {

    public coordinateNotation: CoordinateNotation = "Deg";
    public distanceUnit: DistanceUnits = "NM";
        
    constructor() {
        super();
        makeObservable(this, {
            coordinateNotation: observable,
            distanceUnit: observable,
            scaleLineUnit: computed,
            setDistanceUnit: action.bound,
            setScaleLineUnit: action.bound,
            setCoordinateNotation: action.bound,
        });
    }          

    public get scaleLineUnit(): ScaleLineUnits {
        return getScaleLineUnit(this.distanceUnit);
    }

    public setDistanceUnit(units: DistanceUnits) {
        this.distanceUnit = units;
    }

    public setScaleLineUnit(units: ScaleLineUnits) {
        this.distanceUnit = getDistanceUnit(units);
    }

    public setCoordinateNotation(notation: CoordinateNotation) {
        this.coordinateNotation = notation;
    }
}

export class UnitsStore extends UnitsBaseStore {

    public get getState(): UnitsState {
        const { coordinateNotation, distanceUnit } = this;
        return { coordinateNotation, distanceUnit};
    }

    public setState(state: Partial<UnitsState>) {
        state = { ...state };
        super.setState(state);
    }
}

export function getScaleLineUnit(unit: DistanceUnits): ScaleLineUnits {
    switch (unit) {
        case "km":
        case "m":
            return "metric";
        default:
            return "nautical";
    }
}

export function getDistanceUnit(units: ScaleLineUnits, currentUnit?: DistanceUnits): DistanceUnits {
    if (units === "metric") {
        if (currentUnit == 'km')
            return currentUnit;
        return 'm';
    }
    else {
        if (currentUnit == 'cable')
            return currentUnit;
        return 'NM';
    }
}
